import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=d5fa7de0"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5fa7de0')) {
      api.createRecord('d5fa7de0', component.options)
    } else {
      api.reload('d5fa7de0', component.options)
    }
    module.hot.accept("./Appointments.vue?vue&type=template&id=d5fa7de0", function () {
      api.rerender('d5fa7de0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/appointment/Appointments.vue"
export default component.exports